var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, } from '@kareo/design-system';
import FacesheetConfigurationForm from 'shared-assets/facesheet-ui/components/FacesheetCustomization/FacesheetConfigurationForm';
var FacesheetCustomizationModal = function (_a) {
    var links = _a.links, widgets = _a.widgets, toggleModal = _a.toggleModal, submitConfiguration = _a.submitConfiguration;
    var _b = useState(links), linksState = _b[0], setLinksState = _b[1];
    var _c = useState(widgets), widgetsState = _c[0], setWidgetsState = _c[1];
    useEffect(function () {
        setLinksState(links);
        setWidgetsState(widgets);
    }, [links, widgets]);
    var handleChange = function (event) {
        var checkboxSelected = event.target.value.split('-');
        var groupName = checkboxSelected[0];
        var componentName = checkboxSelected[1];
        if (groupName === 'link') {
            var newLinksState = linksState === null || linksState === void 0 ? void 0 : linksState.map(function (link) {
                if (link.linkName === componentName) {
                    return __assign(__assign({}, link), { enabled: event.target.checked });
                }
                return link;
            });
            setLinksState(newLinksState);
        }
        else if (groupName === 'widget') {
            var newWidgetState = widgetsState === null || widgetsState === void 0 ? void 0 : widgetsState.map(function (widget) {
                if (widget.widgetName === componentName) {
                    return __assign(__assign({}, widget), { enabled: event.target.checked });
                }
                return widget;
            });
            setWidgetsState(newWidgetState);
        }
    };
    return (React.createElement(Box, { component: "span", margin: 1 },
        React.createElement(Dialog, { fullWidth: true, onClose: toggleModal, open: true },
            React.createElement(DialogTitle, { id: "form-dialog-title", disableTypography: true },
                React.createElement(Typography, { variant: "h2", component: "div" }, "Customize View")),
            React.createElement(DialogContent, { dividers: true },
                React.createElement(FacesheetConfigurationForm, { links: linksState, widgets: widgetsState, handleChange: handleChange })),
            React.createElement(DialogActions, null,
                React.createElement(Box, { m: 1.5 },
                    React.createElement(Button, { onClick: function () {
                            toggleModal();
                        }, variant: "text", color: "vitality" }, "Cancel"),
                    React.createElement(Button, { onClick: function () {
                            toggleModal();
                            submitConfiguration(linksState, widgetsState);
                        }, color: "vitality" }, "Save"))))));
};
export default FacesheetCustomizationModal;
